// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"486b8ee8","253":"63697c31","539":"0fe8fff4","630":"2a78cb6d","920":"0fe8fff4"}[chunkId] + ".chunk.css";
};